module.exports = __webpack_public_path__ + "img/sjzs.09885ffd.png";